import { useTheme } from '../../hooks/useTheme';

import { NAV_THEMES } from './nav-tokens';
import NebariLogoGlyph from './NebariLogoGlyph';

interface NebariLogoMarkProps {
  /** Outer tile size. The glyph scales with it. */
  size?: number;
}

/** The brand mark as the design sets it: the glyph knocked out in white on a
 *  dark-green rounded tile, rather than a bare glyph tinted with the theme. */
export default function NebariLogoMark({ size = 32 }: NebariLogoMarkProps) {
  const { theme } = useTheme();
  const t = NAV_THEMES[theme];
  return (
    <span
      className="flex shrink-0 items-center justify-center"
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.3,
        background: t.barkDark,
      }}
    >
      <NebariLogoGlyph size={Math.round(size * 0.58)} color="#ffffff" />
    </span>
  );
}
